var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"1.5em"}},[_c('b-icon',{attrs:{"icon":_vm.icon,"variant":_vm.variant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }